const RESIZE_DEBOUNCE_MS = 200;

const BuildPlansTimeline = {
	list: null,
	items: [],
	resizeTimer: null,

	init() {
		const scrollWrap = document.querySelector('.build-plans__scroll');
		this.list = scrollWrap?.querySelector('.tabs_list_container') || null;
		this.items = this.list ? [...this.list.children] : [];
		if (!this.items.length) return;

		new MutationObserver(() => this.sync()).observe(this.list, {
			subtree: true,
			attributes: true,
			attributeFilter: ['class'],
		});

		window.addEventListener('resize', () => {
			clearTimeout(this.resizeTimer);
			this.resizeTimer = setTimeout(() => this.sync(), RESIZE_DEBOUNCE_MS);
		});
		window.addEventListener('load', () => this.sync());

		this.sync();
	},

	getActiveIndex() {
		const idx = this.items.findIndex((el) => el.classList.contains('active'));
		return idx >= 0 ? idx : 0;
	},

	sync() {
		const idx = this.getActiveIndex();
		this.items.forEach((el, i) => {
			const passed = i <= idx;
			if (el.classList.contains('is-passed') !== passed) el.classList.toggle('is-passed', passed);
		});

		const first = this.items[0];
		const active = this.items[idx];
		const firstCenter = first.offsetTop + first.offsetHeight / 2;
		const activeCenter = active.offsetTop + active.offsetHeight / 2;
		this.list.style.setProperty('--plans-progress-h', `${Math.max(0, activeCenter - firstCenter)}px`);
	},
};

export default BuildPlansTimeline;
